module.exports = new __parcel__URL__("dashboard_divider.b00239f4.png").toString();